import _ from "lodash";

export default {
  callSnackbar(state, payload) {
    state.SnackHandler = payload;
  },
  callNav(state, payload) {
    state.nav = payload;
  },
  changeHireJob(state, payload) {
    state.hirejobs[payload.id][payload.property] = payload.value;
  },
  modify(state, payload) {
    // eslint-disable-next-line no-console
    state[payload.property] = payload.value;
  },
  modifyMultiple(state, payload) {
    payload.forEach((element: any) => {
      state[element.property] = element.value;
    });
  },
  sort(state, payload) {
    if (payload.sort === "Oldest") {
      state[payload.property] = _.sortBy(state[payload.property], [
        "startDate"
      ]);
    }
    if (payload.sort === "Latest") {
      state[payload.property] = _.sortBy(state[payload.property], [
        "startDate"
      ]).reverse();
    }
    if (payload.sort === "Unapproved") {
      state[payload.property] = _.sortBy(state[payload.property], [
        "status"
      ]).reverse();
    }
    if (payload.sort === "Approved") {
      state[payload.property] = _.sortBy(state[payload.property], ["status"]);
    }
  }
};
